const { mergeMap } = require("rxjs/operators");
const { ofType } = require("redux-observable");

const { kyc: kycApi } = require("@doctoroncallcom/api");

const {
  CREATE_KYC_USER,
  GET_KYC_USER,
  UPDATE_KYC_USER,
} = require("./constants");

const {
  createKycUserSuccess,
  createKycUserError,

  getKycUserSuccess,
  getKycUserError,

  updateKycUserSuccess,
  updateKycUserError,
} = require("./actions");

const createKycUser = (action$, state$, { api }) =>
  action$.pipe(
    ofType(CREATE_KYC_USER),
    mergeMap((action) =>
      kycApi
        .setKycUser(api, {
          userId: action.payload.userId,
          type: action.payload.type,
          icBack: action.payload.icBack,
          icFront: action.payload.icFront,
          passportImage: action.payload.passportImage,
          profileImage: action.payload.profileImage,
          name: action.payload.name,
          number: action.payload.number,
        })
        .then((response) => createKycUserSuccess(response.data))
        .catch((error) => createKycUserError(error))
    )
  );

const getKycUser = (action$, state$, { api }) =>
  action$.pipe(
    ofType(GET_KYC_USER),
    mergeMap((action) =>
      kycApi
        .getKycUser(api)
        .then((response) => getKycUserSuccess(response.data))
        .catch((error) => getKycUserError(error))
    )
  );
const updateKycUser = (action$, state$, { api }) =>
  action$.pipe(
    ofType(UPDATE_KYC_USER),
    mergeMap((action) =>
      kycApi
        .updateKycUser(api, {
          userId: action.payload.userId,
          type: action.payload.type,
          icBack: action.payload.icBack,
          icFront: action.payload.icFront,
          passportImage: action.payload.passportImage,
          profileImage: action.payload.profileImage,
          name: action.payload.name,
          number: action.payload.number,
        })
        .then((response) => updateKycUserSuccess(response.data))
        .catch((error) => updateKycUserError(error))
    )
  );
module.exports = {
  createKycUser,
  getKycUser,
  updateKycUser,
};
